import service from "../request";
const baseUrl = window.globalUrl.HOME_API;
// 统计信息-柱状图
export const selectExpertNumberByAreaCode = (params) => {
  return service({
    url: `${baseUrl}/trade-website/consult/selectExpertNumberByAreaCode`,
    method: "get",
    params: params,
  });
};
// 图表区域-饼状图
export const selectConsultArea = (params) => {
  return service({
    url: `${baseUrl}/trade-website/consult/selectConsultArea`,
    method: "get",
    params: params,
  });
};
//专家及解答列表
export const selectExpertNumber = (params) => {
  return service({
    url: `${baseUrl}/trade-website/consult/selectExpertNumber`,
    method: "get",
    params: params,
  });
};